import $ from 'jquery'
import GameManager from '../GameManager';
import { FontSizeMultiplier, GameDataConfig, GameDataManager, SingleScenarioConfig } from './interfaces';
import { toast } from 'react-toastify';
import { CoreBaseApi, CoreBaseApiBasicResult, CoreBaseApiResult } from '../Api/CoreBaseApi';

/**
 * General helper methods
 */
export default class Tools {
	private static _dummyAPI: CoreBaseApi = null;

	public static gameDataManager: GameDataManager<GameDataConfig<SingleScenarioConfig>> = null;
	private static _initialScenarios: SingleScenarioConfig[];
	public static init(initialScenarios: SingleScenarioConfig[]): void {
		Tools._initialScenarios = initialScenarios;
	}
	public static updateCurrentScenarioArea = (scenarioIndx: number, currentAreaIndx: number): Promise<boolean> => {
		return Tools.getSaveData().then((savedData: GameDataManager<GameDataConfig<SingleScenarioConfig>>) => {
			savedData.data.scenarios[scenarioIndx].area = currentAreaIndx;
			return Tools.saveGame(savedData);
		});
	}
	public static saveGame<TManagerType extends GameDataManager<any>> (data: TManagerType): Promise<boolean> {
		return Tools.getApi().store.saveData('saved-game-bs', JSON.stringify(data.data)).then((result: CoreBaseApiBasicResult) => {
			return result.succeeded;
		});
	}
	public static getSaveData<TManagerType extends GameDataManager<any>> (forceMostRecentSavedData?: boolean): Promise<TManagerType> {
		if(this.gameDataManager && !forceMostRecentSavedData) {
			return new Promise<TManagerType>((success) => {
				success(this.gameDataManager as TManagerType);
			});
		}

		return Tools.getApi().store.getData('saved-game-bs').then((result: CoreBaseApiResult<string>) => {
			let savedDataRaw = result.data;
			let savedData: GameDataConfig<SingleScenarioConfig> = null;
			if(savedDataRaw) {
				savedData = JSON.parse(savedDataRaw);
			} else {
				savedData = {
					lastVisitedScenarioIndx: -1,
					isVisibleFocusEnabled: true,
					isAnimationsEnabled: true,
					fontSizeMultiplier: FontSizeMultiplier.small,
					isAudioEnabled: true,
					isClosedCaptionEnabled: true,
					isMotionEnabled: true,
					scenarios: Tools._initialScenarios
				};
			}

			Tools.gameDataManager = new GameDataManager(savedData);

			return Tools.gameDataManager as TManagerType;
		})
	}

	public static getApi() : CoreBaseApi {
		if(!(window as any)['core-api'] && !Tools._dummyAPI) {
			Tools._dummyAPI = new CoreBaseApi();
			Tools._dummyAPI.init();
		}
		return (window as any)['core-api'];
	}

	public static updateTextSize() {
		Tools.getSaveData().then((savedData: GameDataManager<GameDataConfig<SingleScenarioConfig>>) => {
			const body = document.body;
			body.classList.remove('large-text');
			body.classList.remove('default-text');
			body.classList.remove('small-text');

			switch(savedData.data.fontSizeMultiplier) {
				case FontSizeMultiplier.small:
					body.classList.add('small-text');
					break;
				case FontSizeMultiplier.med:
					body.classList.add('default-text');
					break;
				case FontSizeMultiplier.big:
					body.classList.add('large-text');
					break;
			}
		})
	}

	public static setHudVisibilityState(isVisible: boolean) {
		const prop = isVisible ? 'core_show_hud' : 'core_hide_hud';

		if((window as any)[prop]) {
			(window as any)[prop]();
		}
	}

	/**
	 * Call this for any divs' onKeyUp callback and it will make sure when enter is pressed it will act as a normal mouse click
	 */
	public static mapDivEnterToClick(args: any): void {
		if(args.key === 'Enter') {
			$(args.target as any).trigger('click');
		}
	}

	public static showToastNotification(msg: string) {
		toast(msg);
	}

	public static shuffle(array: any) {
		let currentIndex = array.length,  randomIndex;
	  
		// While there remain elements to shuffle.
		while (currentIndex != 0) {
	  
		  // Pick a remaining element.
		  randomIndex = Math.floor(Math.random() * currentIndex);
		  currentIndex--;
	  
		  // And swap it with the current element.
		  [array[currentIndex], array[randomIndex]] = [
			array[randomIndex], array[currentIndex]];
		}
	  
		return array;
	  }

	public static updateWindow = (windowToUse: string, target?: string): void => {
		//setWindow(window);
		let url = new URL(window.location.href);
		let search_params = url.searchParams;
		
		search_params.set('w', windowToUse);

		url.search = search_params.toString();

		if(target) {
			window.open(url.toString(), target)
		} else {
			window.location.href = url.toString();
		}
	}

	public static addOnColorSchemeChanged(onChanged: (isDarkMode: boolean) => void) : any {
		// const method = () => {
		// 	onChanged(this.isUsingDarkMode());
		// };
		// window.matchMedia('(prefers-color-scheme: dark)')
		// 	.addEventListener('change', method);

		// return method;
	}

	public static removeOnColorSchemeChanged(method: any) : void {
		// window.matchMedia('(prefers-color-scheme: dark)')
		// 	.removeEventListener('change', method);
	}

	public static isUsingDarkMode = (): boolean => {
		// return window.matchMedia('(prefers-color-scheme: dark)').matches;
		return false;
	}

	public static set508OutlineVisibleState(isVisible: boolean) {
		const showOutlineClass = 'show-outline';
		const hideOutlineClass = 'hide-outline';
		if(isVisible) {
			if(!document.body.classList.contains(showOutlineClass)){
				document.body.classList.add(showOutlineClass);
			}

			if(document.body.classList.contains(hideOutlineClass)){
				document.body.classList.remove(hideOutlineClass);
			}
		} else {
			if(document.body.classList.contains(showOutlineClass)){
				document.body.classList.remove(showOutlineClass);
			}

			if(!document.body.classList.contains(hideOutlineClass)){
				document.body.classList.add(hideOutlineClass);
			}
		}
	}

	public static set508FocusToBodyOfPage() {
		Tools.set508Focus(document.body);
	}

	public static set508Focus(htmlElement: HTMLElement) {
		setTimeout(() => {
			htmlElement.focus();
		}, 250);
	}

	public static isTesting() {
		return (window as any)['core-unit-test'];
	}

	public static isFilePath(str: string): boolean {
		if(str.indexOf('.') === -1) {
			return false;
		}
		const extension = str.substring(str.lastIndexOf('.')).toLocaleLowerCase();
		return extension === '.png' || extension === '.jpg' || extension === '.jpeg'; //making sure it has an extension
	}

	public static sortByProperty(propertyName: string): any {
		var sortOrder = 1;
		if(propertyName[0] === "-") {
			sortOrder = -1;
			propertyName = propertyName.substr(1);
		}
		return (a: any,b: any) => {
			var result = (a[propertyName] < b[propertyName]) ? -1 : (a[propertyName] > b[propertyName]) ? 1 : 0;
			return result * sortOrder;
		}
	}

	public static getGameManager(): GameManager {
		return (window as any)['core-gm'];
	}

	public static getSaveDataOrNull = (): GameDataConfig<SingleScenarioConfig> => {
		let savedDataRaw = localStorage.getItem('saved-game-bs');
		let savedData: GameDataConfig<SingleScenarioConfig> = null;
		if(savedDataRaw) {
			savedData = JSON.parse(savedDataRaw);
		} else {
			return null;
		}
	
		return savedData;
	}

	public static playOneShotSound = (url: string, onDone?: () => void, isDialog?: boolean): void => {
		Tools.getSaveData().then((savedData: GameDataManager<GameDataConfig<SingleScenarioConfig>>) => {
			Tools.getGameManager().SoundManager.playSound({
				src: url,
				autoPlay: true,
				isDialog: isDialog,
				controls: false,
				enableClosedCaptioning: false,
				loop: false,
				muted: !savedData.data.isAudioEnabled,
				onEnded: onDone,
				oneShot: true,
				playsInline: true,
				volume: 1,
				pitch: 0
			})
		})
		
	}

	public static forceRerenderUI = (uiName: string, instanceName?: string) => {
		if(!(window as any)[uiName]) {
			return undefined;
		}
		
		if(instanceName) {
			if(!(window as any)[uiName][instanceName]) {
				return undefined;
			}
			return (window as any)[uiName][instanceName]();
		}
	
		if(!(window as any)[uiName]['main']) {
			return undefined;
		}
		return (window as any)[uiName]['main']();
	}

	public static forceRerenderAllNonHudUIs = (gm: GameManager) => {
		const uis = gm.UiManager._uis;
		for(var indx = 0; indx < uis.length; indx++) {
			const ui = uis[indx];
			if(ui.tag !== 'Hud') {
				(window as any)[ui.name]['main']();
			}
		}
	}

	/**
	 * @returns True if the site is running in ios
	 */
	public static isios(): boolean{
		return [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		  ].includes(navigator.platform)
		  // iPad on iOS 13 detection
		  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	}

	/**
	 * True if in localhost
	 */
	public static isLocalhost(): boolean {
		return window.location.hostname === 'localhost';
	}

	/**
	 * True if the supplied string is a JSON string
	 * @param str The string to evaluate
	 */
	public static isJSON(str: string): boolean {
		return (str.startsWith('{') && str.endsWith('}')) || 
        ((str.startsWith('[') && str.endsWith(']')));
	}

	/**
	 * Generates a brand new guid
	 */
	public static generateGuid(): string {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	/**
	 * Generates a random integer between a minimum (included) and a maximum (included) number
	 * @param min The minimun to include
	 * @param max The maximum number to include
	 */
	public static  randomInteger(min: number, max: number) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	  }
	public static randomizeItemsInArray(array: any[]) {
		for (let i = array.length - 1; i > 0; i--) {
			let j = Math.floor(Math.random() * (i + 1));
			let temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
	}
}
